import { useState } from "react";
import { SearchField } from "@wine2trace/ui/FormComponents";
import useLabels from "../../hooks/useLabels";
import { SkeletonTable } from "../Skeleton/Skeleton";
import DataTable from "./index";
import { searchRows } from "./searchRows";

// Above this many rows the list gets a search.
export const SEARCH_FROM = 10;

// A list inside a section: a skeleton while loading, a message when empty, otherwise the table, with a search
// above it when the list is long. searchValues(row) → the values the search looks in (no search without it).
// onRowClick: see DataTable.
const SearchableTable = ({ rows, columns, getRowKey, ariaLabel, isLoading = false, emptyText, searchValues, onRowClick }) => {
  const [getLabel] = useLabels();
  const [query, setQuery] = useState("");
  if (isLoading) return <SkeletonTable colCount={columns.length} withToolbar={false} />;
  if (!rows?.length) return <p className="detail_empty">{emptyText}</p>;

  const searchable = Boolean(searchValues) && rows.length > SEARCH_FROM;
  return (
    <>
      {searchable && <SearchField value={query} onChange={setQuery} placeholder={getLabel("search")} />}
      <DataTable
        columns={columns}
        rows={searchable ? searchRows(rows, query, searchValues) : rows}
        getRowKey={getRowKey}
        ariaLabel={ariaLabel}
        onRowClick={onRowClick}
      />
    </>
  );
};

export default SearchableTable;
